import { Button } from "@shared/ui/Button";
import { ButtonGroup } from "@shared/ui/ButtonGroup";
import { MessageSquare, BookOpen, Users, X } from "lucide-react";
import { VideoUIActiveTab } from "../../videoUI.types";
import { useChatVisibility } from "@platform/features/chat/hooks/useChatVisibility";

export type Props = {
  activeTab: VideoUIActiveTab;
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  onClose: () => void;
  onTabChange: (tab: VideoUIActiveTab) => void;
  unreadCount: number;
};

export function VideoUINavigation({
  activeTab,
  onClose,
  onTabChange,
  unreadCount = 0,
}: Props) {
  const { shouldShowChat } = useChatVisibility();

  const tabs = [
    ...(shouldShowChat
      ? [
          {
            label: "Chat",
            iconComponent: MessageSquare,
            name: "chat" as VideoUIActiveTab,
          },
        ]
      : []),
    {
      label: "Materials",
      iconComponent: BookOpen,
      name: "materials" as VideoUIActiveTab,
    },
    {
      label: "Attendees",
      iconComponent: Users,
      name: "roster" as VideoUIActiveTab,
    },
  ];

  return (
    <div className="flex flex-col text-brand-800 w-full sticky top-0 z-20">
      <Button
        onClick={onClose}
        iconComponent={X}
        variant="ghost"
        className="absolute top-3 right-4 z-20"
      />
      <div className="border-b border-brand-800">
        <div className="relative -bottom-[1px] flex flex-row gap-8 w-full items-center justify-between px-4 pt-4">
          <ButtonGroup
            buttons={tabs.map((tab) => ({
              label: tab.label,
              iconComponent: tab.iconComponent,
              onClick: () => onTabChange(tab.name),
              isActive: activeTab === tab.name,
              badgeCount: tab.name === "chat" ? unreadCount : undefined,
            }))}
            layout="tabs"
            isWithShadow={false}
          />
        </div>
      </div>
    </div>
  );
}

export default VideoUINavigation;
